import { combineReducers } from 'redux';

import leaderboard from './leaderboard';

export default combineReducers({
    leaderboard,
});